import { LoaderFunctionArgs, redirect } from 'react-router';
import { createBrowserRouter } from 'react-router-dom';
import Empty from 'src/pages/Empty';
import Layout from 'src/pages/layout';
import Mkt01 from 'src/pages/mkt01';
import Mkt02 from 'src/pages/mkt02';
import TermsPopup from 'src/pages/terms';
import ErrorBoundaryPage from 'src/pages/error';

const validTelecom = (routeName:string, args: LoaderFunctionArgs<any> | undefined) => {
  const { params } = args ?? {};

  if (!params) redirect("/");

  const paramCheck = !!params!.telecom && ['0', '1', '2'].includes(params!.telecom);
  if (paramCheck) return true;
  else {
    const redirectUrl = !!params!.pcode ? `/${routeName}/${params!.pcode}` : `/${routeName}`;
    return redirect(redirectUrl);
  }

};

export const router = createBrowserRouter([
  {
    errorElement: <ErrorBoundaryPage />,
    children: [
      {
        element: <Layout />,
        children: [
          {
            element: <Mkt01 />,
            path: '/mkt01/:pcode/:requestID',
            id: 'mkt01',
            children: [
              {
                path: ':telecom',
                loader: (args) => validTelecom('mkt01', args),
                children: [{ path: ':telecomActive' }],
              },
            ],
          },
          {
            element: <Mkt02 />,
            path: '/mkt02/:pcode/:requestID/:telecom',
            id: 'mkt02',
            loader: (args) => validTelecom('mkt02', args),
            children: [
              {
                path: ':telecomActive',
              },
            ],
          },
          { element: <TermsPopup />, id: 'terms', path: '/terms/:requestID/:telecom/:termsIdx/:termsOrderIdx' },
        ],
      },
      { path: '*', element: <Empty /> },
    ],
  },
]);
